export default "__VITE_ASSET__ugFXk6vP__"